import SearchBar from "../../components/universal/SearchBar";
import Navbar from "../../components/universal/Navbar";
import { useState,useEffect } from "react";
import AllChurches from "../Churches/AllChurches";
import AllResources from '../Resources/AllResource';
import AllCarecells from '../Carcells/allcarcells'
import AllProgram from '../Program/AllProgram'
import AllTeam from '../Teams/AllTeam'
import AllBulletin from '../Bulletin/allbulletin'
import Bulletin from '../Bulletin/bulletin'
import Team from '../Teams/Teams'
import Program from '../Program/Program'
import Carecells from '../Carcells/carcells'
import Resources from '../Resources/Resource'
import Churches from "../Churches/Church";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AllVideos from "../Videos/AllVideos";
import Videos from "../Videos/Videos";
import AllCategories from "../Categories/AllCategories";
import Categories from "../Categories/Categories";
import AllCurriculum from "../Curriculum/AllCurriculum";
import Curriculum from "../Curriculum/Curriculum";
import { FaCaretDown } from "react-icons/fa";
import Twg from '../TWG/Twg'
import AllTwg from '../TWG/AllTwg'
import Journals from "../Journals/Journals";
import AllJournals from "../Journals/AllJournals";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import AddChurch from '../../screens/Channel/addchannel'
import { Link } from "react-router-dom";
function AddField() {
  const tabs = [
  "Churches"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
   const { userInfo, accessToken } = useSelector((state) => state.user);
   const [startIndex, setStartIndex] = useState(0);
   const location = useLocation(); // ✅ Add this line


   const { church, channel } = location.state || {};
   const [selectedChannelName, setSelectedChannelName] = useState(() => {
     try {
       const saved = JSON.parse(localStorage.getItem("channel") || "null");
       return (
         saved?.channelName ||
         saved?.churchName ||
         saved?.name ||
         ""
       );
     } catch {
       return "";
     }
   });
   useEffect(() => {
     const onStorage = (e) => {
       if (e.key === "channel") {
         try {
           const next = JSON.parse(e.newValue || "null");
           setSelectedChannelName(
             next?.channelName ||
               next?.churchName ||
               next?.name ||
               ""
           );
         } catch {
           setSelectedChannelName("");
         }
       }
     };
     const onChannelChange = (e) => {
       setSelectedChannelName(
         e?.detail?.channelName ||
           e?.detail?.churchName ||
           e?.detail?.name ||
           ""
       );
     };
     window.addEventListener("storage", onStorage);
     window.addEventListener("channel:change", onChannelChange);
     return () => {
       window.removeEventListener("storage", onStorage);
       window.removeEventListener("channel:change", onChannelChange);
     };
   }, []);

   const channelTitle =
     channel?.channelName ||
     channel?.churchName ||
     channel?.name ||
     church?.channelName ||
     church?.churchName ||
     church?.name ||
     selectedChannelName ||
     "Channel";
   const maxVisible = 9  ;

  useEffect(() => {
    const activeIndex = tabs.indexOf(activeTab);
    if (activeIndex < startIndex) {
      setStartIndex(activeIndex);
    } else if (activeIndex >= startIndex + maxVisible) {
      setStartIndex(activeIndex - maxVisible + 1);
    }
  }, [activeTab]);

  return (
    <div className="App bg-[#191919] h-fit min-h-screen w-full overflow-x-hidden flex p-4">
      <Navbar />
      <div className={`min-w-0 flex-1 ${userInfo.roleCode!='17dwer8'?'md:pl-32':''} md:pt-0 pt-20`}>
        <div className="flex min-w-0 flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} />



          <div className="flex min-w-0 items-center justify-between gap-4">
            <div className="min-w-0 truncate text-white text-2xl md:text-3xl font-semibold">
              {channelTitle}
            </div>
            <Link
              to={"/channel/all"}
              onClick={() => {
                const church = localStorage.getItem("channel");
                if (church) {
                  localStorage.removeItem("channel");
                }
              }}
            >
              <button className=" text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                See All Channels
              </button>
            </Link>
          </div>


          <div className="MAIN-CONTENT flex min-w-0 h-full gap-4 text-white">


            {activeTab === "Churches" && (
              <>
                <div className="w-full min-w-0">
                  <AddChurch church={church} />
                </div>

              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default AddField;
